'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';

import { Footer } from '@/app/_components/Footer';
import { DONATION_ROUTES, ROUTES } from '@/constants';

import { DonationSubHeader } from './_components/DonationLayout/DonationSubHeader';

const DonationBenefitToastController = dynamic(
  () =>
    import('./_components/DonationBenefitToastController').then(
      (mod) => mod.DonationBenefitToastController,
    ),
  { ssr: false },
);

const FloatingGiftBoxController = dynamic(
  () =>
    import('./_components/FloatingGiftBoxController').then(
      (mod) => mod.FloatingGiftBoxController,
    ),
  { ssr: false },
);

const LocalFestaUrlNormalizer = dynamic(
  () =>
    import('./event/localfesta/_components/UrlNormalizer').then(
      (mod) => mod.UrlNormalizer,
    ),
  { ssr: false },
);

const GlobalPopupController = dynamic(
  () =>
    import('./_components/GlobalPopupController').then(
      (mod) => mod.GlobalPopupController,
    ),
  { ssr: false },
);

/**
 * footer를 제외하고 렌더링할 페이지 (정규표현식 패턴)
 */
const EXCLUDED_FOOTER_PATTERNS: RegExp[] = [
  /^\/donation\/my/,
  /^\/donation\/invite\/.+$/,
  /^\/donation\/callback\/.+\/.+$/,
  /^\/donation\/callback\/.+$/,
  /^\/donation\/event\/market/,
];

/**
 * footer를 제외하고 렌더링할 페이지
 */
const EXCLUDED_FOOTER_PATHNAMES: string[] = [
  DONATION_ROUTES.MY_INVITE.pathname,
  DONATION_ROUTES.HOMETOWN_BUSINESS_ORDER.pathname,
  DONATION_ROUTES.DONATION_INVITE.pathname,
  DONATION_ROUTES.KB_CHECK_CARD.pathname,
  ROUTES.LOGIN.pathname,
  ROUTES.JOIN_COMMON.pathname,
  ROUTES.JOIN_COMPLETE.pathname,
  ROUTES.EASY_CERTIFICATION.pathname,
  ROUTES.EASY_CERTIFICATION_CALLBACK.pathname,
  ROUTES.LOCALFESTA.pathname,
  ROUTES.LOCALFESTA_APPLY.pathname,
  '/donation' + ROUTES.LOCALFESTA.pathname,
  '/donation' + ROUTES.LOCALFESTA_APPLY.pathname,
  DONATION_ROUTES.MARKET.pathname,
  '/event/kb-check-card',
];

/**
 * 서브 헤더를 제외하고 렌더링할 페이지
 * - 풀블리드 이벤트 랜딩처럼 독립 비주얼이 필요한 페이지
 */
const EXCLUDED_SUB_HEADER_PATHNAMES: string[] = [
  DONATION_ROUTES.KB_CHECK_CARD.pathname,
  // 검색 페이지는 자체 검색 헤더(fixed)를 가져 서브헤더와 겹친다 — 독립 비주얼로 둔다.
  DONATION_ROUTES.SEARCH.pathname,
  '/event/kb-check-card',
];

const Layout = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();

  const shouldShowFooter =
    !EXCLUDED_FOOTER_PATTERNS.some((pattern) => pattern.test(pathname || '')) &&
    !EXCLUDED_FOOTER_PATHNAMES.includes(pathname || '');
  const shouldShowSubHeader = !EXCLUDED_SUB_HEADER_PATHNAMES.includes(
    pathname || '',
  );

  return (
    <>
      <DonationBenefitToastController />
      <FloatingGiftBoxController />
      <LocalFestaUrlNormalizer />
      <GlobalPopupController />
      {shouldShowSubHeader ? <DonationSubHeader /> : null}
      {children}
      {shouldShowFooter ? <Footer /> : null}
    </>
  );
};

export default Layout;
